import discountImg from 'assets/img/espn/discount.png';
import disneyImg from 'assets/img/espn/disney.png';
import film1Img from 'assets/img/espn/film1.png';
import tvChannelImg from 'assets/img/espn/tv-channel.png';
import { ContentUtil } from 'utils';

import { content } from '../espn-proposal.content';
import ProposalType from '../proposal-type.enum';
import { ProposalInfo } from '../types/proposal-info';

const contentUtil = new ContentUtil({ content, componentName: 'ESPNProposal' });

const proposals = [
  {
    type: 'disney',
    img: disneyImg,
    ctaLink: 'https://www.ziggo.nl/televisie/films-en-series/disney-plus', // TODO: add correct link
    treatmentId: 'TBD', // TODO: add correct treatment id
    types: [ProposalType.Streamer, ProposalType.AltijdAlles],
  },
  {
    type: 'film1',
    img: film1Img,
    ctaLink: 'https://www.ziggo.nl/televisie/films-en-series/film1', // TODO: add correct link
    treatmentId: 'TBD', // TODO: add correct treatment id
    types: [ProposalType.Streamer, ProposalType.AltijdAlles],
  },
  {
    type: 'tvChannel',
    img: tvChannelImg,
    ctaLink: 'https://www.ziggo.nl/televisie/films-en-series/tvChannel', // TODO: add correct link
    treatmentId: 'TBD', // TODO: add correct treatment id
    types: [ProposalType.Zapper, ProposalType.AltijdAlles],
  },
  {
    type: 'discount',
    img: discountImg,
    ctaLink: 'https://www.ziggo.nl/televisie/films-en-series/discount', // TODO: add correct link
    treatmentId: 'TBD', // TODO: add correct treatment id
    types: [ProposalType.Streamer, ProposalType.Zapper, ProposalType.AltijdAlles],
  },
];

export const getProposalsForType = (type: ProposalType, treatmentIds: string[], isSoho: boolean): ProposalInfo[] => {
  return proposals
    .filter((proposal) => proposal.types.includes(type))
    .map((proposal) => {
      const months = treatmentIds.includes(proposal.treatmentId) ? '6' : '3';
      const price = isSoho ? '2,-' : '2,50';

      return {
        image: proposal.img,
        title: contentUtil.translateToString(`proposals.${proposal.type}.title`, { months, price }),
        text: contentUtil.translateHtml(`proposals.${proposal.type}.text`, { months, price }),
        cta: contentUtil.translateToString(`proposals.${proposal.type}.cta`),
        ctaLink: proposal.ctaLink,
      };
    });
};
